export const MASTER_ID_COLUMN_ID_FOR_JOIN = '@@MASTER_ID@@';